import loadADIInvoices, { DefaultDate } from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    invoiceResults: state.ADIGlobalData.ADIInvoiceStore.invoiceResults,
    allLocationsInvoice: state.ADIGlobalData.ADIInvoiceStore.allLocationsInvoice,
    currenySymbol: state.context.session.currency?.currencySymbol,
    multipleInvoiceResult: state.ADIGlobalData.ADIInvoiceStore.multipleInvoiceResult,
    getInvoiceParameters: state.ADIGlobalData.ADIInvoiceStore.loadInvoiceParameters,
});

const mapDispatchToProps = {
    loadADIInvoices,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface InvoiceAgingInfoStyles {
    container?: InjectableCss;
    title?: TypographyProps;
    tableContainer?: InjectableCss;
    tableHeader?: InjectableCss;
    tableHeaderContainer?: InjectableCss;
    tableContentContainer?: InjectableCss;
    tableContent?: InjectableCss;
    toolTip?: InjectableCss;
    mobileTableContentContainer?: GridContainerProps;
    mTTotalGridItem?: GridItemProps;
    mTAgedGridItem?: GridItemProps;
    mTTotalAmountGridItem?: GridItemProps;
    mTCurrentGridItem?: GridItemProps;
    mTDPDGridItem?: GridItemProps;
    mtTableHeader?: InjectableCss;
    mtTableContent?: InjectableCss;
    mtTableContentDPDContainer?: InjectableCss;
    tabTableContentDPDContainer?: InjectableCss;
    mtTableContentDPD?: InjectableCss;
    griditeminside?: InjectableCss;
}

export const tableStyles: InvoiceAgingInfoStyles = {
    tableContainer: {
        css: css`
          //background-color: ${ADIColors.white};
        `,
    },
    container: {
        css: css`
            margin-top: 0px;
        `,
    },
    title: {
        variant: "h4",
        css: css`
            background-color: ${ADIColors.white};
            color: ${ADIColors.darkBlue1};
            padding: 15px 0 12px 12px;
            margin-bottom: 8px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            background-color: transparent;
                            padding: 15px 0px 0px 0px;
                        `,

                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    tableHeaderContainer: {
        css: css`
            background-color: ${ADIColors.white};
            display: flex;
            padding: 7px 0px 7px 30px;
            margin-bottom: 8px;
        `,
    },
    tableHeader: {
        css: css`
            width: 11%;
            display: flex;
            flex-basis: 11%;
            align-items: center;
            padding: 7px 10px;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            color: ${getColor("commom.backgroundContrast")};
            position: relative;

            &:last-child {
                width: calc(56% - 11px);
                flex-basis: calc(56% - 11px);
                text-align: center;
                border-radius: 4px;
                background-color: ${ADIColors.lightblue};
                margin-left: 28px;
                align-items: center;
                justify-content: center;
                display: flex;
                margin-right: 11px;
            }

            &.align-end {
                justify-content: flex-end;
            }

            :hover span {
                display: inline;
            }
        `,
    },
    tableContentContainer: {
        css: css`
            background-color: ${ADIColors.white};
            display: flex;
            padding: 7px 0px 7px 30px;
            margin-bottom: 8px;
        `,
    },
    tableContent: {
        css: css`
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            width: 11%;
            flex-basis: 11%;
            padding: 8px 10px;
            display: flex;

            &.align-end {
                justify-content: flex-end;
                padding-right: 8px;
            }

            &.aging-price {
                width: 14%;
                flex-basis: 14%;
                border-left: solid 2px ${ADIColors.white1};
                text-align: center;
                justify-content: center;
            }

            &.aging-price.left-space {
                margin-left: 32px;
            }

            span {
                color: ${getColor("primary")};
                font-weight: bold;
                cursor: pointer;

                :hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    toolTip: {
        css: css`
            position: absolute;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            font-weight: normal;
            font-stretch: normal;
            font-style: italic;
            line-height: 1.29;
            letter-spacing: normal;
            text-align: center;
            color: ${ADIColors.darkBlue1};
            width: 153px;
            margin: 0 0 1px;
            padding: 6px 8px 16px;
            box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.25);
            background-color: ${ADIColors.gray6};
            display: flex;
            align-items: center;
            border: none;
            border-radius: 5px;
            z-index: 10;
            bottom: 100%;
            display: none;
            :after {
                content: "";
                position: absolute;
                left: 9%;
                top: calc(100% - 10px);
                margin-left: 5px;
                border: 8px solid ${ADIColors.gray6};
                box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.18);
                border-color: transparent transparent ${ADIColors.gray6} ${ADIColors.gray6};
                transform: rotate(315deg);
            }

            &.center-align {
                :after {
                    left: 60%;
                }
            }
        `,
    },
    mTTotalGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`flex-direction: row;`,
                    css`flex-direction: row;`,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTAgedGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`flex-direction: row;`,
                    css`flex-direction: row;`,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTTotalAmountGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            padding: 3px 10px;
            border-bottom: 1px solid ${getColor("common.border")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    flex-direction: row;
                    max-width: 100%;
                    flex-basis: 100%;
                    border-bottom: none;
                `,
                css`
                    flex-direction: row;
                    max-width: 100%;
                    flex-basis: 100%;
                    border-bottom: none;
                `,
                    css`flex-direction: row;`,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                        padding-bottom: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    griditeminside:{
        css: css`
        flex-basis: 50%;
        max-width: 50%;
        flex-direction: column;
        padding: 3px 10px;
        border-bottom: 1px solid ${getColor("common.border")};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`flex-direction: row;`,
                css`flex-direction: row;`,
                null,
                null,
                null,
            ])
        
        }
    `,

    },

    mTCurrentGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: row;
                        max-width: 100%;
                        flex-basis: 100%;
                        padding-top: 0;s
                    `,
                    css`
                        flex-direction: row;
                        max-width: 100%;
                        flex-basis: 100%;
                        border-bottom: none;
                    `,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                        padding-bottom: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTDPDGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            flex-direction: column;
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        border-top: 1px solid ${ADIColors.gray3};
                        padding-top: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mtTableHeader: {
        css: css`
            font-weight: bold;
            font-size: 14px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-right: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mtTableContent: {
        css: css` 
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [css` font-size: 14px;
                padding-left: 4px;font-weight: normal; `,],"max",); 
            }}
        `,
    },
    mtTableContentDPDContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            span {
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` font-weight: normal; `,],"max",); 
                }}
            }
        `,
    },
    tabTableContentDPDContainer: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
        `,
    },
    mtTableContentDPD: {
        css: css`
            max-width: 50%;
            flex-basis: 50%;
            &:first-child {
                order: 1;
            }
            &:nth-child(2) {
                order: 3;
            }
            &:nth-child(3) {
                order: 2;
            }
            &:nth-child(4) {
                order: 4;
            }
            span {
                color: ${getColor("primary")};
                font-weight: bold;
                cursor: pointer;

                :hover {
                    text-decoration: underline;
                }
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` font-weight: normal; `,],"max",); 
                }}
            }
        `,
    },
    mobileTableContentContainer: {
        css: css`
            background-color: ${getColor("common.background")};
            @media only screen and (min-width: 768px) and (max-width: 1080px) { max-width:100%; }
            > ${GridOffset} {
                width: 100%;
                margin: 0;
            }
        `,
    },
};

const styles = tableStyles;

const InvoiceAgingInfo = ({
    invoiceResults,
    allLocationsInvoice,
    currenySymbol,
    multipleInvoiceResult,
    loadADIInvoices,
    getInvoiceParameters,
}: Props) => {
    const agingInfo = invoiceResults?.properties;
    const [isMobile, setIsMobile] = React.useState(false);
    const [isTab, setIsTab] = React.useState(false);
    React.useEffect(() => {
        const onWindowResize = () => {
            const windowWidth = window.innerWidth;
            setIsMobile(windowWidth < 767);
            setIsTab(windowWidth >= 768 && windowWidth <= 1023);
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    if (!agingInfo || (allLocationsInvoice && !multipleInvoiceResult)) {
        return null;
    }

    const formatYearData = (dateString: string) => {
        if (!dateString) return;

        const date = new Date(dateString);

        function getAbbreviatedMonthName(month: number) {
            month = Math.max(0, Math.min(11, month));
            return new Date(0, month).toLocaleDateString("en-US", { month: "short" });
        }

        const month = getAbbreviatedMonthName(date.getMonth());
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = month + " " + day + ", " + year;
        return formattedDate;
    };
    
    const loadDPDInvoice = (filtetType: string) => {
        let formattedFromDate =  DefaultDate(true, false, 365);
        loadADIInvoices({
            ...getInvoiceParameters,
            dpdFilterData: filtetType,
            dpdFilterType: "AI",
            poNumber: "",
            invoiceNumber: "",
            refrencenumber: "",
            invoiceFilterType: "type",
            invoiceFilterData: "Invoice",
            invoiceTypeDesc: "Open",
            invoiceType: "1",
            properties: JSON.stringify({
                invoicefiltertype: "type",
                invoicefilterdata: "Invoice",
                dpdfiltertype: "AI",
                dpdfilterdata: filtetType,
            }),
            formattedFromDate: formattedFromDate,
        });
    };
 
    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.title}>{translate("Aging Information")}</Typography>
            {isMobile ? (
                <StyledWrapper {...styles.tableContainer}>
                    {allLocationsInvoice && multipleInvoiceResult ? (
                        <GridContainer {...styles.mobileTableContentContainer}>
                            <GridItem {...styles.mTTotalGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Total:")}{" "}
                                    <Typography {...styles.toolTip}>
                                        {translate("Total number of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent}>
                                    {multipleInvoiceResult?.totRecords}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTAgedGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>{translate("Aged:")}</StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent}>
                                    {formatYearData(multipleInvoiceResult?.curDate || "")}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTTotalAmountGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Total Amount:")}
                                    <Typography {...styles.toolTip} className="center-align">
                                        {translate("Sum of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totGrand).toFixed(2)}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTCurrentGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Current:")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totCurrent).toLocaleString()}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTDPDGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Days Past Due (DPD)")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContentDPDContainer}>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price left-space">
                                        {`${translate("1 - 30")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot01_30,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                        {`${translate("31 - 60")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot31_60,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                        {`${translate("61 - 90")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot61_90,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                        {`${translate("91 +")}: ${parseFloat(multipleInvoiceResult?.tot90_Over).toFixed(
                                            2,
                                        )}`}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    ) : (
                        <GridContainer {...styles.mobileTableContentContainer}>
                            <GridItem {...styles.mTTotalGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Total:")}{" "}
                                    <Typography {...styles.toolTip}>
                                        {translate("Total number of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.mtTableContent}>{agingInfo.totalItems}</StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTAgedGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>{translate("Aged:")}</StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent}>
                                    {formatYearData(agingInfo.aging)}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTTotalAmountGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Total Amount:")}
                                    <Typography {...styles.toolTip} className="center-align">
                                        {translate("Sum of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(agingInfo.totalBalance).toLocaleString()}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTCurrentGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Current:")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(agingInfo.currentBalance).toLocaleString()}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTDPDGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Days Past Due (DPD)")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContentDPDContainer}>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price left-space">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("1-30")}>{`${translate(
                                            "1 - 30",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance1_30).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("31-60")}>{`${translate(
                                            "31 - 60",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance31_60).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("61-90")}>{`${translate(
                                            "61 - 90",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance61_90).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("91")}>{`${translate(
                                            "91 +",
                                        )}: ${parseFloat(agingInfo.balanceOver90).toFixed(2)}`}</Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    )}
                </StyledWrapper>
            ) : isTab ? (
                <StyledWrapper {...styles.tableContainer}>
                    {allLocationsInvoice && multipleInvoiceResult ? (
                        // <GridContainer {...styles.mobileTableContentContainer}>
                        <GridContainer >
                               <GridItem {...styles.griditeminside}>
                            {/* <GridItem {...styles.mTTotalGridItem}> */}
                                {/* <StyledWrapper {...styles.mtTableHeader}> */}
                                <StyledWrapper>
                                    {translate("Total:")}{" "}
                                    <Typography {...styles.toolTip}>
                                        {translate("Total number of Invoices and Credit Memos")}
                                    </Typography>
                                    {multipleInvoiceResult?.totRecords}
                                </StyledWrapper>
                                {/* <StyledWrapper {...styles.mtTableContent}> */}
                                <StyledWrapper>
                                    {/* {multipleInvoiceResult?.totRecords} */}
                                </StyledWrapper>
                            </GridItem>
                            {/* <GridItem {...styles.mTTotalAmountGridItem}> */}
                            <GridItem {...styles.griditeminside}>
                                {/* <StyledWrapper {...styles.mtTableHeader} className="align-end"> */}
                                <StyledWrapper>
                                    {translate("Total Amount:")}
                                    <Typography {...styles.toolTip} className="center-align">
                                        {translate("Sum of Invoices and Credit Memos")}
                                    </Typography>
                                    {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totGrand).toLocaleString()}
                                </StyledWrapper>
                                {/* <StyledWrapper {...styles.mtTableContent} className="align-end"> */}
                                <StyledWrapper>
                                    {/* {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totGrand).toLocaleString()} */}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.griditeminside}>
                                <StyledWrapper {...styles.mtTableHeader}>{translate("Aged:")}
                                {formatYearData(multipleInvoiceResult?.curDate || "")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent}>
                                    {/* {formatYearData(multipleInvoiceResult?.curDate || "")} */}
                                </StyledWrapper>
                            </GridItem>
                         

                            
                          
                            {/* <GridItem {...styles.mTCurrentGridItem}> */}
                            <GridItem {...styles.griditeminside}>
                                {/* <StyledWrapper {...styles.mtTableHeader} className="align-end"> */}
                                <StyledWrapper>
                                    {translate("Current:")}
                                    {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totCurrent).toLocaleString()}
                                </StyledWrapper>
                                {/* <StyledWrapper {...styles.mtTableContent} className="align-end"> */}
                                <StyledWrapper>
                                    {/* {currenySymbol}
                                    {parseFloat(multipleInvoiceResult?.totCurrent).toLocaleString()} */}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTDPDGridItem}>
                                {/* <StyledWrapper {...styles.mtTableHeader}> */}
                                <StyledWrapper>
                                    {translate("Days Past Due (DPD)")}
                                </StyledWrapper>
                                {/* <StyledWrapper {...styles.tabTableContentDPDContainer}> */}
                                <StyledWrapper>
                                    {/* <StyledWrapper {...styles.mtTableContentDPD} className="aging-price left-space"> */}
                                    <StyledWrapper>
                                        {`${translate("1 - 30")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot01_30,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    {/* <StyledWrapper {...styles.mtTableContentDPD} className="aging-price"> */}
                                    <StyledWrapper>
                                        {`${translate("31 - 60")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot31_60,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    {/* <StyledWrapper {...styles.mtTableContentDPD} className="aging-price"> */}
                                    <StyledWrapper>
                                        {`${translate("61 - 90")}: ${currenySymbol}${parseFloat(
                                            multipleInvoiceResult?.tot61_90,
                                        ).toFixed(2)}`}
                                    </StyledWrapper>
                                    {/* <StyledWrapper {...styles.mtTableContentDPD} className="aging-price"> */}
                                    <StyledWrapper>
                                        {`${translate("91 +")}: ${parseFloat(multipleInvoiceResult?.tot90_Over).toFixed(
                                            2,
                                        )}`}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    ) : (
                        <GridContainer {...styles.mobileTableContentContainer}>
                            <GridItem {...styles.mTTotalGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Total:")}{" "}
                                    <Typography {...styles.toolTip}>
                                        {translate("Total number of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.mtTableContent}>{agingInfo.totalItems}</StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTAgedGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>{translate("Aged:")}</StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent}>
                                    {formatYearData(agingInfo.aging)}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTTotalAmountGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Total Amount:")}
                                    <Typography {...styles.toolTip} className="center-align">
                                        {translate("Sum of Invoices and Credit Memos")}
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(agingInfo.totalBalance).toLocaleString()}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTCurrentGridItem}>
                                <StyledWrapper {...styles.mtTableHeader} className="align-end">
                                    {translate("Current:")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.mtTableContent} className="align-end">
                                    {currenySymbol}
                                    {parseFloat(agingInfo.currentBalance).toLocaleString()}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.mTDPDGridItem}>
                                <StyledWrapper {...styles.mtTableHeader}>
                                    {translate("Days Past Due (DPD)")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.tabTableContentDPDContainer}>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price left-space">
                                                <Typography as={"span"} onClick={() => loadDPDInvoice("1-30")}>{`${translate(
                                            "1 - 30",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance1_30).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                                <Typography as={"span"} onClick={() => loadDPDInvoice("31-60")}>{`${translate(
                                            "31 - 60",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance31_60).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                                <Typography as={"span"} onClick={() => loadDPDInvoice("61-90")}>{`${translate(
                                            "61 - 90",
                                        )}: ${currenySymbol}${parseFloat(agingInfo.balance61_90).toFixed(
                                            2,
                                        )}`}</Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mtTableContentDPD} className="aging-price">
                                                <Typography as={"span"} onClick={() => loadDPDInvoice("91")}>{`${translate(
                                            "91 +",
                                        )}: ${parseFloat(agingInfo.balanceOver90).toFixed(2)}`}</Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    )}
                </StyledWrapper>
            ) : (
                <StyledWrapper {...styles.tableContainer}>
                    <StyledWrapper {...styles.tableHeaderContainer}>
                        <StyledWrapper {...styles.tableHeader}>
                            {translate("Invoice-Total")}{" "}
                            <Typography {...styles.toolTip}>
                                {translate("Total number of Invoices and Credit Memos")}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.tableHeader}>{translate("Aged")}</StyledWrapper>
                        <StyledWrapper {...styles.tableHeader} className="align-end">
                            {translate("Total Amount")}
                            <Typography {...styles.toolTip} className="center-align">
                                {translate("Sum of Invoices and Credit Memos")}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.tableHeader} className="align-end">
                            {translate("Current")}
                        </StyledWrapper>
                        <StyledWrapper {...styles.tableHeader}>{translate("Days Past Due (DPD)")}</StyledWrapper>
                    </StyledWrapper>

                    {allLocationsInvoice && multipleInvoiceResult ? (
                        <StyledWrapper {...styles.tableContentContainer}>
                            <StyledWrapper {...styles.tableContent}>{multipleInvoiceResult?.totRecords}</StyledWrapper>
                            <StyledWrapper {...styles.tableContent}>
                                {formatYearData(multipleInvoiceResult?.curDate || "")}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(multipleInvoiceResult?.totGrand).toLocaleString()}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(multipleInvoiceResult?.totCurrent).toLocaleString()}
                            </StyledWrapper>

                            <StyledWrapper {...styles.tableContent} className="aging-price left-space">
                                {`${translate("1 - 30")}: ${currenySymbol}${parseFloat(
                                    multipleInvoiceResult?.tot01_30,
                                ).toLocaleString()}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("31 - 60")}: ${currenySymbol}${parseFloat(
                                    multipleInvoiceResult?.tot31_60,
                                ).toLocaleString()}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("61 - 90")}: ${currenySymbol}${parseFloat(
                                    multipleInvoiceResult?.tot61_90,
                                ).toLocaleString()}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("91 +")}: ${parseFloat(multipleInvoiceResult?.tot90_Over).toLocaleString()}`}
                            </StyledWrapper>
                        </StyledWrapper>
                    ) : (
                        <StyledWrapper {...styles.tableContentContainer}>
                            <StyledWrapper {...styles.tableContent}>{agingInfo.totalItems}</StyledWrapper>
                            <StyledWrapper {...styles.tableContent}>{formatYearData(agingInfo.aging)}</StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(agingInfo.totalBalance).toLocaleString()}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(agingInfo.currentBalance).toLocaleString()}
                            </StyledWrapper>

                            <StyledWrapper {...styles.tableContent} className="aging-price left-space">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("1-30")}>{`${translate(
                                    "1 - 30",
                                )}: ${currenySymbol}${parseFloat(agingInfo.balance1_30).toLocaleString()}`}</Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("31-60")}>{`${translate(
                                    "31 - 60",
                                )}: ${currenySymbol}${parseFloat(agingInfo.balance31_60).toLocaleString()}`}</Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("61-90")}>{`${translate(
                                    "61 - 90",
                                )}: ${currenySymbol}${parseFloat(agingInfo.balance61_90).toLocaleString()}`}</Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                            <Typography as={"span"} onClick={() => loadDPDInvoice("91")}>{`${translate(
                                    "91 +",
                                )}: ${parseFloat(agingInfo.balanceOver90).toLocaleString()}`}</Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(InvoiceAgingInfo),
    definition: {
        group: "Invoice History",
        displayName: "Invoice Aging Info",
    },
};

export default widgetModule;
